import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPrint = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "#000",
		d: "M7.75 13.5a.75.75 0 0 0 0 1.5v-1.5Zm4.5 1.5a.75.75 0 0 0 0-1.5V15Zm3-5.5a.75.75 0 0 0 0-1.5v1.5Zm-.5-1.5a.75.75 0 0 0 0 1.5V8ZM2.25 5.75v.75h15.5V5H2.25v.75Zm16 .5h-.75v7.5H19v-7.5h-.75Zm-16.5 7.5h.75v-7.5H1v7.5h.75Zm3.25.5v-.75H2.25V15H5v-.75Zm12.75 0v-.75H15V15h2.75v-.75Zm-16-.5H1c0 .69.56 1.25 1.25 1.25v-1.5a.25.25 0 0 1 .25.25h-.75Zm16.5 0h-.75a.25.25 0 0 1 .25-.25V15c.69 0 1.25-.56 1.25-1.25h-.75Zm-.5-8v.75a.25.25 0 0 1-.25-.25H19C19 5.56 18.44 5 17.75 5v.75Zm-15.5 0V5C1.56 5 1 5.56 1 6.25h1.5a.25.25 0 0 1-.25.25v-.75Zm3 5.5V12h9.5v-1.5h-9.5v.75Zm9.75.25h-.75V17h1.5v-5.5H15Zm-.25 5.75v-.75h-9.5V18h9.5v-.75ZM5 17h.75v-5.5h-1.5V17H5Zm.25.25v-.75a.5.5 0 0 1 .5.5h-1.5a1 1 0 0 0 1 1v-.75ZM15 17h-.75a.5.5 0 0 1 .5-.5V18a1 1 0 0 0 1-1H15Zm-.25-5.75V12a.5.5 0 0 1-.5-.5h1.5a1 1 0 0 0-1-1v.75Zm-9.5 0v-.75a1 1 0 0 0-1 1h1.5a.5.5 0 0 1-.5.5v-.75Zm0-8.5v.75h9.5V2h-9.5v.75ZM15 3h-.75v2h1.5V3H15ZM5 5h.75V3h-1.5v2H5Zm9.75-2.25v.75a.5.5 0 0 1-.5-.5h1.5a1 1 0 0 0-1-1v.75Zm-9.5 0V2a1 1 0 0 0-1 1h1.5a.5.5 0 0 1-.5.5v-.75Zm2.5 11.5V15h4.5v-1.5h-4.5v.75Zm7.5-5.5V8h-.5v1.5h.5v-.75Z"
	})]
});
const ForwardRef = forwardRef(SvgPrint);
export { ForwardRef as ReactComponent };
